module.exports = __webpack_public_path__ + "img/case_3.956af163.png";